import { BasicClientCommand } from "./BasicClientCommand";
/**
 * Created with IntelliJ IDEA.
 * User: Aaron
 * Date: 19.06.12
 * Time: 16:09
 * To change this template use File | Settings | File Templates.
 */


export class BasicNetworkUpdateCommand extends BasicClientCommand {

    public execute(commandVars: any = null): void {

    }
}

